import React, { useState, useEffect } from 'react';
import { useThemeMode } from '../../context/contextTheme';
import BtnToggle from './btn-toggle/index';
import Logo from './logo/index';
import Searchbar from './search-bar/index';
import BellIcon from './btn-bell/index';
import ProfileSmall from './profile/index';
import useDeviceDetect from '../../utils/deviceDetect';
import './style.css';

const Navbar = () => {
  const { theme } = useThemeMode();
  const { isMobile, isTablet, isDesktop } = useDeviceDetect();
  const [searchVisibility, setSearchVisibility] = useState(false);

  useEffect(() => {
    // Collapse sidebar on mobile, expand on larger screens
    if (isMobile || isTablet || isDesktop) {
      setSearchVisibility(false);
    } else {
      setSearchVisibility(true);
    }
  }, [isMobile, isTablet, isDesktop, setSearchVisibility]);

  return (
    <nav 
      className="navbar shadow-sm"
      style={{
        background: theme.background2,
        borderBottom: `1px solid ${theme.border}`,
      }}>
      <div className="container-fluid">
        {/* Sidebar toggle */}
        <BtnToggle />
        {/* Centered Searchbar */}
        <Logo />
        
        {searchVisibility && (
          <div className="flex-grow-1 px-4 mx-3">
            <Searchbar />
          </div>
        )}

        {/* Right icons */}
        <div className="d-flex align-items-center gap-2">
          {/* <ThemeSwitcher /> */}
          <BellIcon />
          {/* <ExternalLinks /> */}
          <ProfileSmall />          
        </div>
      </div>
    </nav>
  );
};

export default Navbar;